import React from 'react'
import PanelHeader from '../header/panelHeader'
import TaskLogListTable from '../list/taskLogList'

const TaskLogList = () => {
    return (
        <div>
            <PanelHeader />
            <TaskLogListTable />
        </div>
    )
}

export default TaskLogList
